import { cn } from "@/lib/utils"

type FancyBrandProps = {
  className?: string
  size?: "sm" | "md" | "lg" | "xl"
  withHash?: boolean
}

const SIZE_STYLES: Record<NonNullable<FancyBrandProps["size"]>, string> = {
  sm: "text-sm font-black tracking-tight",
  md: "text-base font-black tracking-tight sm:text-lg",
  lg: "text-xl font-black tracking-tight sm:text-2xl",
  xl: "text-3xl font-black tracking-tight sm:text-5xl lg:text-6xl",
}

export function FancyBrand({
  className,
  size = "md",
  withHash = true,
}: FancyBrandProps) {
  return (
    <span
      className={cn(
        "inline-flex items-baseline gap-[0.04em] leading-tight whitespace-nowrap",
        SIZE_STYLES[size],
        className
      )}
    >
      {withHash && (
        <span className="text-zielarz-green drop-shadow-[0_1px_0_rgba(0,0,0,0.12)]">
          #
        </span>
      )}

      <span
        className={cn(
          "bg-gradient-to-b from-zielarz-lime via-zielarz-green to-zielarz-green bg-clip-text text-transparent",
          "drop-shadow-[0_1px_0_rgba(255,255,255,0.18)]",
          "dark:drop-shadow-[0_1px_0_rgba(0,0,0,0.28)]"
        )}
      >
        Zielarz
      </span>
    </span>
  )
}

export default FancyBrand
